import * as moment from 'moment';
import { RinknetPlayerInformation } from './rnPlayerInformation.model';
import constants from '../constants';

export class Player {
    constructor(json?: any) {
        this.id = json && json.player_id || null;
        this.firstName = json && json.player_first_name || null;
        this.lastName = json && json.player_last_name || null;
        this.email = json && json.email || null;
        this.rnid = json && json.player_rnid || null;
        this.primaryTeamID = json && json.player_primary_team_id || null;
        this.primaryTeamName = json && json.player_primary_team_name || null;
        this.primaryTeamRNID = json && json.player_primary_team_rnid || null;
        this.secondaryTeamID = json && json.player_secondary_team_id || null;
        this.secondaryTeamName = json && json.player_secondary_team_name || null;
        this.secondaryTeamRNID = json && json.player_secondary_team_rnid || null;
        this.thirdTeamID = json && json.player_third_team_id || null;
        this.thirdTeamName = json && json.player_third_team_name || null;
        this.thirdTeamRNID = json && json.player_third_team_rnid || null;
        this.positionID = json && json.player_position_id || null;
        this.position = json && json.player_position || null;
        this.positionShort = json && json.player_position_short || null;
        this.positionType = json && json.player_position_type || null;
        this.height = json && json.player_height || null;
        this.jerseyNumber = json && json.player_jersey_number || null;
        this.secJerseyNumber = json && json.player_sec_jersey_number || null;
        this.thirdJerseyNumber = json && json.player_third_jersey_number || null;
        this.nationality = json && json.player_nationality || null;
        this.countryLongName = json && json.country_long_name || null;
        this.shot = json && json.player_shot || null;
        this.catch = json && json.player_catch || null;
        this.agentID = json && json.agent_id || null;
        this.agentCompanyID = json && json.agent_company_id || null;
        this.agentFirstName = json && json.agent_first_name || null;
        this.agentLastName = json && json.agent_last_name || null;
        this.agentEmail = json && json.agent_email || null;
        this.agentPhone = json && json.agent_phone || null;
        this.isMale = json && json.is_male || null;
        this.summerStreet = json && json.summer_street || null;
        this.summerCity = json && json.summer_city || null;
        this.summerProvince = json && json.summer_province || null;
        this.summerProvinceName = json && json.summer_province_name || null;
        this.summerPostal = json && json.summer_postal || null;
        this.summerCountry = json && json.summer_country || null;
        this.summerCountryName = json && json.summer_country_name || null;
        this.summerPhone = json && json.summer_phone || null;
        this.winterStreet = json && json.winter_street || null;
        this.winterCity = json && json.winter_city || null;
        this.winterProvince = json && json.winter_province || null;
        this.winterProvinceName = json && json.winter_province_name || null;
        this.winterPostal = json && json.winter_postal || null;
        this.winterCountry = json && json.winter_country || null;
        this.winterCountryName = json && json.winter_country_name || null;
        this.winterPhone = json && json.winter_phone || null;
        this.cellPhone = json && json.cell_phone || null;
        this.isSkater = (json && json.is_skater != null) ? json.is_skater : true;
        this.birthPlace = json && json.player_birth_place || null;
        this.headshot = json && json.headshot || null;
        this.hometown = json && json.player_hometown || null;
        this.weight = json && json.player_weight || null;

        if(json && json.player_birth_date) {
            this.birthDate = moment.utc(json.player_birth_date);
        }

        this.age = 0;
        if(this.birthDate) {
            this.age = moment().diff(this.birthDate, 'years');
        }

        this.showWinterAddress = false;
        if(this.winterStreet || this.winterCity || this.winterProvince || this.winterPostal || this.winterCountry || this.winterPhone) {
            this.showWinterAddress = true;
        }

        //Convert "6.03.25" into 6'3.25" then into 75.25 inches
        if (json && json.player_height) {
            let feet: number = parseInt(json.player_height.substring(0,json.player_height.indexOf(".")));
            let inches: number = parseFloat(json.player_height.substring(json.player_height.indexOf(".")+1));
            this.height = (feet * 12) + inches;
        }
    }

    id: number;
    firstName: string;
    lastName: string;
    email: string;
    rnid: number;
    primaryTeamID: number;
    primaryTeamName: string;
    primaryTeamRNID: number;
    secondaryTeamID: number;
    secondaryTeamName: string;
    secondaryTeamRNID: number;
    thirdTeamID: number;
    thirdTeamName: string;
    thirdTeamRNID: number;
    positionID: number;
    position: string;
    positionShort: string;
    positionType: string;
    height: number;
    weight: number;
    birthDate: moment.Moment;
    age: number;
    jerseyNumber: number;
    secJerseyNumber: number;
    thirdJerseyNumber: number;
    nationality: number;
    countryLongName: string;
    shot: string;
    catch: string;
    agentID: number;
    agentCompanyID: number;
    agentFirstName: string;
    agentLastName: string;
    agentEmail: string;
    agentPhone: string;
    isMale: boolean;
    summerStreet: string;
    summerCity: string;
    summerProvince: number;
    summerProvinceName: string;
    summerPostal: string;
    summerCountry: number;
    summerCountryName: string;
    summerPhone: string;
    winterStreet: string;
    winterCity: string;
    winterProvince: number;
    winterProvinceName: string;
    winterPostal: string;
    winterCountry: number;
    winterCountryName: string;
    winterPhone: string;
    cellPhone: string;
    isSkater: boolean;
    birthPlace: string;
    headshot: string;
    hometown: string;

    showWinterAddress: boolean;

    toJSON() {
        return {
            id: this.id,
            player_first_name: this.firstName,
            player_last_name: this.lastName,
            player_rnid: this.rnid,
            player_primary_team_id: this.primaryTeamID,
            player_primary_team_name: this.primaryTeamName,
            player_primary_team_rnid: this.primaryTeamRNID,
            player_secondary_team_id: this.secondaryTeamID,
            player_secondary_team_name: this.secondaryTeamName,
            player_secondary_team_rnid: this.secondaryTeamRNID,
            player_third_team_id: this.thirdTeamID,
            player_third_team_name: this.thirdTeamName,
            player_third_team_rnid: this.thirdTeamRNID,
            player_position_id: this.positionID,
            player_position: this.position,
            player_position_short: this.positionShort,
            player_position_type: this.positionType,
            player_height: this.height,
            player_weight: this.weight,
            player_birth_date: this.birthDate,
            player_jersey_number: this.jerseyNumber,
            player_sec_jersey_number: this.secJerseyNumber,
            player_third_jersey_number: this.thirdJerseyNumber,
            player_nationality: this.nationality,
            country_long_name: this.countryLongName,
            player_shot: this.shot,
            player_catch: this.catch,
            agent_id: this.agentID,
            agent_company_id: this.agentCompanyID,
            agent_first_name: this.agentFirstName,
            agent_last_name: this.agentLastName,
            agent_email: this.agentEmail,
            agent_phone: this.agentPhone,
            is_male: this.isMale,
            summer_street: this.summerStreet,
            summer_city: this.summerCity,
            summer_province: this.summerProvince,
            summer_province_name: this.summerProvinceName,
            summer_postal: this.summerPostal,
            summer_country: this.summerCountry,
            summer_country_name: this.summerCountryName,
            summer_phone: this.summerPhone,
            winter_street: this.winterStreet,
            winter_city: this.winterCity,
            winter_province: this.winterProvince,
            winter_province_name: this.winterProvinceName,
            winter_postal: this.winterPostal,
            winter_country: this.winterCountry,
            winter_country_name: this.winterCountryName,
            winter_phone: this.winterPhone,
            cell_phone: this.cellPhone
        }
    }

    toRinknetPlayerInformation(): RinknetPlayerInformation {
        let rnPlayerInfo: RinknetPlayerInformation = new RinknetPlayerInformation();

        rnPlayerInfo.firstName = this.firstName;
        rnPlayerInfo.lastName = this.lastName;
        rnPlayerInfo.playerRNID = this.rnid;
        rnPlayerInfo.teamRNID = this.primaryTeamRNID;
        rnPlayerInfo.email = this.email;

        rnPlayerInfo.positionID = this.positionID;
        rnPlayerInfo.positionName = this.position;
        rnPlayerInfo.positionShortName = this.positionShort;

        rnPlayerInfo.height = this.height;
        rnPlayerInfo.weight = this.weight;

        rnPlayerInfo.birthdate = this.birthDate;
        rnPlayerInfo.teamJerseyNumber = this.jerseyNumber;
        rnPlayerInfo.nationalityID = this.nationality;
        
        rnPlayerInfo.shot = this.shot;
        rnPlayerInfo.agentID = this.agentID;
        rnPlayerInfo.agentFirstName = this.agentFirstName;
        rnPlayerInfo.agentLastName = this.agentLastName;
        rnPlayerInfo.streetAddress = this.summerStreet;
        rnPlayerInfo.city = this.summerCity;
        rnPlayerInfo.provinceID = this.summerProvince;
        rnPlayerInfo.postalCode = this.summerPostal;
        rnPlayerInfo.countryID = this.summerCountry;
        rnPlayerInfo.addressPhone = this.summerPhone;
        rnPlayerInfo.cellphone = this.cellPhone;
        rnPlayerInfo.homeTown = this.birthPlace;
        
        return rnPlayerInfo;
    }

    compare(comparisonPlayer: Player): boolean {
        let isEqual: boolean = true;

        if(this.shot != comparisonPlayer.shot) { isEqual = false; }
        if(this.nationality != comparisonPlayer.nationality) { isEqual = false; }
        if(this.birthDate != comparisonPlayer.birthDate) { isEqual = false; }
        if(this.height != comparisonPlayer.height) { isEqual = false; }
        if(this.weight != comparisonPlayer.weight) { isEqual = false; }
        if(this.cellPhone != comparisonPlayer.cellPhone) { isEqual = false; }
        if(this.summerStreet != comparisonPlayer.summerStreet) { isEqual = false; }
        if(this.summerCity != comparisonPlayer.summerCity) { isEqual = false; }
        if(this.summerProvince != comparisonPlayer.summerProvince) { isEqual = false; }
        if(this.summerPostal != comparisonPlayer.summerPostal) { isEqual = false; }
        if(this.summerCountry != comparisonPlayer.summerCountry) { isEqual = false; }
        if(this.summerPhone != comparisonPlayer.summerPhone) { isEqual = false; }
        if(this.winterStreet != comparisonPlayer.winterStreet) { isEqual = false; }
        if(this.winterCity != comparisonPlayer.winterCity) { isEqual = false; }
        if(this.winterProvince != comparisonPlayer.winterProvince) { isEqual = false; }
        if(this.winterPostal != comparisonPlayer.winterPostal) { isEqual = false; }
        if(this.winterCountry != comparisonPlayer.winterCountry) { isEqual = false; }
        if(this.winterPhone != comparisonPlayer.winterPhone) { isEqual = false; }
        
        return isEqual;
    }
}